
<template>

<div>
   <div class="row mb-1">
       <div class="col-sm-3 "><strong>Название:</strong></div>
       <div class="col-sm-9 ">ООО &laquo;Моторика&raquo;</div>
    </div>
    <div class="row mb-1">
        <div class="col-sm-3 "><strong>Телефон:</strong></div>
        <div class="col-sm-9">8 (800) 707-71-97 (звонок бесплатный)</div>
    </div>
    <div class="row mb-1">
        <div class="col-sm-3 "><strong>Email:</strong></div>
        <div class="col-sm-9">info@motorica.org</div>
    </div>
    <div class="row mb-1">
        <div class="col-sm-3 "><strong>Адрес:</strong></div>
        <div class="col-sm-9">121205, г. Москва, Территория Сколково Инновационного Центра,
        бул. Большой, д. 42, стр. 1, эт. 1 пом. 334, раб. 10
        </div>
    </div>
    <div class="row mb-1">
        <div class="col-sm-3 "><strong>Реквизиты:</strong></div>
        <div class="col-sm-9">ИНН: 7719402047 / ОГРН: 1157746078984</div>
    </div>
    <div class="row mb-1">
        <div class="col-sm-3 "><strong>Cхема проезда:</strong></div>
        <div class="col-sm-9"><img  v-img src="/ru_cheme.jpg" style="width: 100%"></div>
    </div>
   
</div>





</template>
<script>
    import Vue from 'vue';
    import VueImg from 'v-img';
    Vue.use(VueImg);
    //import i18n from '@/lang'
    export default{
        name: 'ru',
        data() {
            return{}
        },
 

    }
</script>

